"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdSkuDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      selfCategoryIds: [],
      selfCategoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        multiple: true,
        checkStrictly: true,
        emitPath: true
      },
      selfCategoryTree: []
    };
  },
  methods: {
    formatMoney: function formatMoney(val) {
      if (val === undefined || val === null || val === '') return '--';
      var n = Number(val);
      if (Number.isNaN(n)) return String(val);
      return n.toFixed(2);
    },
    getPriceDiff: function getPriceDiff() {
      if (this.detail.salePrice == null || this.detail.retail == null) return 0;
      var diff = parseFloat(this.detail.salePrice) - parseFloat(this.detail.retail);
      if (Math.abs(diff) < 0.001) return 0;
      return diff;
    },
    getPriceClass: function getPriceClass() {
      var diff = this.getPriceDiff();
      if (diff > 0) return 'price-up';
      if (diff < 0) return 'price-down';
      return '';
    },
    getAdjustRatio: function getAdjustRatio() {
      if (this.detail.salePrice == null || this.detail.retail == null) return '--';
      var diff = parseFloat(this.detail.salePrice) - parseFloat(this.detail.retail);
      if (Math.abs(diff) < 0.001) return '--';
      var ratio = (diff / parseFloat(this.detail.retail) * 100).toFixed(2);
      return ratio;
    },
    getPreviewList: function getPreviewList() {
      var list = [];
      var main = this.detail && (this.detail.imagePath || this.detail.defaultImagePath);
      if (main) list.push(main);
      var imgs = this.detail && this.detail.imageList || [];
      for (var i = 0; i < imgs.length; i++) {
        var p = imgs[i] && imgs[i].shortPath;
        if (p) list.push(p);
      }
      return list;
    },
    goToSortShow: function goToSortShow() {
      this.$router && this.$router.push({
        path: '/store/sort/show'
      });
    },
    open: function open(row) {
      var _this = this;
      this.detail = {};
      this.selfCategoryIds = [];
      this.visible = true;
      var skuId = row && (row.skuId != null ? row.skuId : row.skuid);
      if (skuId === undefined || skuId === null || skuId === '') {
        this.loading = false;
        this.$message.error('缺少skuId');
        return;
      }
      this.loading = true;

      // jdStoreApi.getSelfCategoryTree().then((res) => {
      //   const tree = res;
      //   this.selfCategoryTree = tree;
      // });

      jdStoreApi.getJdGoodsDetail({
        skuId: skuId
      }).then(function (res) {
        if (res) {
          _this.detail = res;
        }
      }).catch(function () {
        _this.$message.error('获取详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.detail = {};
      this.selfCategoryIds = [];
    }
  }
};